import { render } from "./GridWarehouse.vue?vue&type=template&id=65c154e3"
import script from "./GridWarehouse.vue?vue&type=script&lang=js"
export * from "./GridWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__